import script from "./itemModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemModal.vue?vue&type=script&setup=true&lang=ts"

import "./itemModal.vue?vue&type=style&index=0&id=2f3aae7c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3aae7c"]])

export default __exports__